import { Drill, Cable, Scissors, Radio, HardHat, Wrench } from "lucide-react"
import { Badge } from "@/components/ui/badge"

const services = [
  {
    icon: Drill,
    title: "Horizontal Directional Drilling",
    description: "State-of-the-art HDD technology for installing underground utilities with minimal surface disruption. Currently handling drilling up to 10\" diameter. Ideal for road crossings, river crossings, and environmentally sensitive areas.",
    color: "primary",
    comingSoon: false,
  },
  {
    icon: HardHat,
    title: "Micro Trenching",
    description: "Precision micro trenching services for fiber optic cable and utilities installation in urban and rural environments. Faster deployment with reduced restoration costs.",
    color: "accent",
    comingSoon: false,
  },
  {
    icon: Cable,
    title: "Fiber Pulling",
    description: "Expert fiber optic cable pulling through existing conduit or newly installed pathways. We handle single-mode, multi-mode, and specialty fiber applications.",
    color: "primary",
    comingSoon: false,
  },
  {
    icon: Scissors,
    title: "Fiber Splicing and Testing",
    description: "Certified fusion splicing services with precision equipment. Full OTDR testing and documentation for every splice point.",
    color: "accent",
    comingSoon: true,
  },
  {
    icon: Radio,
    title: "Aerial Installation",
    description: "Overhead cable installation on existing pole infrastructure. Includes strand installation, lashing, and aerial fiber deployment.",
    color: "primary",
    comingSoon: true,
  },
  {
    icon: Wrench,
    title: "Underground Installation",
    description: "Complete underground utility installation including conduit placement, handholes, and junction boxes for robust network infrastructure.",
    color: "accent",
    comingSoon: true,
  },
]

export function ServicesSection() {
  return (
    <section className="border-t border-border/40 bg-muted/30 py-20 md:py-28">
      <div className="container mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="mx-auto mb-16 max-w-2xl text-center">
          <h2 className="mb-4 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            Our <span className="text-primary">Services</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Comprehensive network infrastructure solutions from ground to sky. We handle every aspect of your connectivity needs.
          </p>
        </div>
        
        {/* Services Grid */}
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {services.map((service) => {
            const IconComponent = service.icon
            const isPrimary = service.color === "primary"
            
            return (
              <div
                key={service.title}
                className={`group relative overflow-hidden rounded-xl border border-border/50 bg-card p-6 transition-all hover:border-primary/30 hover:shadow-xl ${service.comingSoon ? "opacity-75" : ""}`}
              >
                {/* Coming Soon Badge */}
                {service.comingSoon && (
                  <Badge className="absolute right-4 top-4 bg-accent text-accent-foreground">
                    Coming Soon
                  </Badge>
                )}
                
                {/* Icon */}
                <div className={`mb-4 inline-flex h-14 w-14 items-center justify-center rounded-xl ${isPrimary ? "bg-primary/10" : "bg-accent/10"}`}>
                  <IconComponent className={`h-7 w-7 ${isPrimary ? "text-primary" : "text-accent"}`} />
                </div>
                
                {/* Content */}
                <h3 className="mb-3 text-xl font-semibold text-foreground">{service.title}</h3>
                <p className={service.comingSoon ? "text-muted-foreground/50" : "text-muted-foreground"}>{service.description}</p>
                
                {/* Hover Accent */}
                <div className={`absolute bottom-0 left-0 h-1 w-full origin-left scale-x-0 transition-transform group-hover:scale-x-100 ${isPrimary ? "bg-primary" : "bg-accent"}`} />
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
